import React, { useEffect, useState } from 'react'
import { toNumber } from 'lodash-es'
// import dayjs from 'dayjs'
import { dayjsInit } from '@ow/utils'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { CalendarStyled, EventStyled } from './styled/calendar'

const WEEKLIST = [
  {
    title: '周一',
    className: 'calendar-title calendar-title-left',
  },
  {
    title: '周二',
    className: 'calendar-title',
  },
  {
    title: '周三',
    className: 'calendar-title',
  },
  {
    title: '周四',
    className: 'calendar-title',
  },
  {
    title: '周五',
    className: 'calendar-title',
  },
  {
    title: '周六',
    className: 'calendar-title',
  },
  {
    title: '周日',
    className: 'calendar-title calendar-title-right',
  },
]
const Calendar = (props) => {
  const [dayList, setDayList] = useState([])
  const { currentDate, extData, createEvent, onEventClick, allowCreateDate } =
    props

  const currentMonth =
    currentDate && currentDate.split('-')[1]
      ? toNumber(currentDate.split('-')[1])
      : toNumber(new Date().getMonth()) + 1

  useEffect(() => {
    const nowMonthFirstDate = `${currentDate}-01`
    const nowWeek = new Date(nowMonthFirstDate).getDay() || 7
    const dateList = []
    const startDay = 2 - nowWeek
    const showDayLength = nowWeek < 6 ? 35 : 42
    for (let i = startDay; i < startDay + showDayLength; i++) {
      const date = new Date(new Date(nowMonthFirstDate).setDate(i))
      const day = dayjsInit(date).format('DD')
      const month = dayjsInit(date).month() + 1
      const dayObject = {
        date: dayjsInit(date).format('YYYY-MM-DD'),
        month,
        day,
      }
      dateList.push(dayObject)
    }
    setDayList(dateList)
  }, [currentDate])

  const allowToCreate = (date) => {
    if (allowCreateDate.length !== 0) {
      if (allowCreateDate[0]) {
        return (
          new Date(date).getTime() >= new Date(allowCreateDate[0]).getTime()
        )
      }
      if (allowCreateDate[1]) {
        return (
          new Date(date).getTime() <= new Date(allowCreateDate[1]).getTime()
        )
      }
    }
    return true
  }
  return (
    <CalendarStyled>
      <div className="calendar-container flex flex-col">
        <div className="content">
          {WEEKLIST.map((list) => {
            return (
              <div className={list.className} key={list.title}>
                {list.title}
              </div>
            )
          })}
        </div>
        <div className="content flex-1">
          {dayList.map((list) => {
            return (
              <div
                className="calendar-box"
                key={list.date}
                onClick={() => {
                  if (allowToCreate(list.date)) {
                    createEvent(list.date)
                  }
                }}
              >
                <div
                  className={clsx(
                    'calendar-date',
                    list.month !== currentMonth && 'calendar-other-date'
                  )}
                >
                  {list.day}
                </div>
                <div className="calendar-event">
                  <div className="event-content">
                    {(extData.data || []).map((ucase) => {
                      if (ucase.date === list.date) {
                        return (
                          <EventStyled
                            key={ucase.id}
                            onClick={(e) => {
                              e.stopPropagation()
                              onEventClick(ucase.data)
                            }}
                          >
                            {/* <span>{ucase.time}</span> */}
                            <div />
                            {ucase.title}
                          </EventStyled>
                        )
                      }
                      return null
                    })}
                  </div>
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </CalendarStyled>
  )
}

Calendar.defaultProps = {
  createEvent: () => {},
  onEventClick: () => {},
  allowCreateDate: [],
  extData: {},
}

Calendar.propTypes = {
  currentDate: PropTypes.string.isRequired,
  createEvent: PropTypes.func,
  onEventClick: PropTypes.func,
  allowCreateDate: PropTypes.shape(),
  extData: PropTypes.shape({
    data: PropTypes.shape(),
  }),
}
export default Calendar
